import type { Audience, UserIdDetails } from '@fluidx/office-fluid-types';
import { getLogicalRing } from 'owa-config';
import { isGulpOrBranchingValue } from 'owa-querystring';
import { getUserConfiguration } from 'owa-session-store';

export function getAudience(): Audience {
    // For now, 'Audience' is only using Dogfood, Local and Production.
    if (isGulpOrBranchingValue) {
        return 'Local';
    }

    const logicalRing = getLogicalRing();
    switch (logicalRing) {
        case 'Dogfood':
            return 'Dogfood';
        case 'Microsoft':
            return 'Microsoft';
        case 'FirstRelease':
        case 'WW':
            return 'Production';
        case 'Unknown':
            return 'Automation';
        default:
            return 'Production';
    }
}

export function getUser(): UserIdDetails {
    const userConfigSettings = getUserConfiguration().SessionSettings;
    return {
        id: userConfigSettings?.UserPuid,
        tenantId: userConfigSettings?.ExternalDirectoryTenantGuid as string,
        userIdSpace: 'OrgIdPuid',
    };
}
